module.exports = __webpack_public_path__ + "static/media/emoji.d63d3d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/OfferingImages/assets/emoji.png
// module id = 492
// module chunks = 0